export default interface ContactEntity {
	_id?: string
	status: Status
	fullname: string
	phone: number
	email: string
	message: string
	response?: string
	_created?: string
	_modified?: string
	_deleted?: boolean
}

export enum Status {
	pendding = 'pending',
	viewed = 'viewed'
}
